import React, { useState, useEffect, useCallback } from 'react';

import information from '~/assets/images/information.svg';

import {  usePendency } from '~/hooks/pendency'

import {
  PendCards,
  PendItem,
  Details,
  PendTitle
} from './styled';

export default function PendencyCard({ pendency}){

  const { setPendencySelected } = usePendency()

  return (
    <PendCards>
      <PendItem>
        <PendTitle>
          <p className="title-challenge">
            Pendência {pendency.number}
          </p>
        </PendTitle>
        <Details onClick={() => setPendencySelected(pendency)}>
          <span>Detalhes</span>
          <img
            src={information}
            alt="Ícone de informações"
          />
        </Details>
      </PendItem>
    </PendCards>
  )
}
